// extracted by mini-css-extract-plugin
export default {"main":"topflight_main__nwOWi","first":"topflight_first__igud7","innercard":"topflight_innercard__m8hD3","second":"topflight_second__Z2hnR","news":"topflight_news__Az4EM"};